module.exports = __webpack_public_path__ + "img/icon-competence-7.0bba6ce7.svg";